import axios from "axios";
import store from "../store";
//var apibaseurl = process.env.VUE_APP_API_URL;
//var apibaseurl = "http://localhost:3000/dev/";
var apibaseurl = "https://6fyr4aqbid.execute-api.ap-south-1.amazonaws.com/dev/";
var auth = "Bearer " + store.getters.authToken;
export default {
  loginUser(user) {
    return axios.post(apibaseurl + "loginUser", JSON.stringify(user), {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  addEmployee(data) {
    return axios.post(apibaseurl + "addEmployee", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  sendOtp(data) {
    return axios.post(apibaseurl + "sendOtp", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json"

      },
    });
  },
  verifyOtp(data) {
    return axios.post(apibaseurl + "verifyOtp", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json"

      },
    });
  },
  addBankdetail(data) {
    return axios.post(apibaseurl + "addBankDetails", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addAddressDetail(data) {
    return axios.post(apibaseurl + "addAddressDetails", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addEducationDetails(data) {
    return axios.post(apibaseurl + "addEducationDetails", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getEmployeeEducationLogById(data) {
    return axios.post(
      apibaseurl + "getEmployeeEducationLogById",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  addEmployeePayrollStructure(data) {
    return axios.post(apibaseurl + "addEmployeePayrollStructure", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addAllEmployeeAttendance(data) {
    return axios.post(apibaseurl + "addAllEmployeeAttendance", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getEmployeePayStructureById(data) {
    return axios.post(
      apibaseurl + "getEmployeePayStructureById",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },

  getDefinePayStructureById(data) {
    return axios.post(
      apibaseurl + "getDefinePayStructureById",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getEmployeeBankLogById(data) {
    return axios.post(
      apibaseurl + "getEmployeeBankLogById",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getEmployeeAddressLogById(data) {
    return axios.post(
      apibaseurl + "getEmployeeAddressLogById",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAllDesignation(data) {
    return axios.post(apibaseurl + "getAllDesignation", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllRole(data) {
    return axios.post(apibaseurl + "getAllRole", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllDepartment(data) {
    return axios.post(apibaseurl + "getAllDepartment", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllLocation(data) {
    return axios.post(apibaseurl + "getAllLocation", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addEmployeeDesignation(data) {
    return axios.post(apibaseurl + "addEmployeeDesignation", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addEmployeeDepartment(data) {
    return axios.post(apibaseurl + "addEmployeeDepartment", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addEmployeeLocation(data) {
    return axios.post(apibaseurl + "addEmployeeLocation", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getEmployeeDepartmentLogById(data) {
    return axios.post(
      apibaseurl + "getEmployeeDepartmentLogById",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getEmployeeLocationLogById(data) {
    return axios.post(
      apibaseurl + "getEmployeeLocationLogById",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getEmployeeDesignationLogById(data) {
    return axios.post(
      apibaseurl + "getEmployeeDesignationLogById",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  addPayrollStructure(data) {
    return axios.post(apibaseurl + "addPayrollStructure", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addAttendanceDetail(data) {
    return axios.post(apibaseurl + "addAttendanceDetail", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getEmployeeAttendanceById(data) {
    return axios.post(
      apibaseurl + "getEmployeeAttendanceById",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getPayStructure(data) {
    return axios.post(apibaseurl + "getPayStructure", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getLeaveDays(data) {
    return axios.post(apibaseurl + "getLeaveDays", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  // addAllEmployeeAttendanceDetail(data) {
  //   return axios.post(
  //     apibaseurl + "addAllEmployeeAttendanceDetail",
  //     JSON.stringify(data),
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: auth,
  //       },
  //     }
  //   );
  // },
  getAllEmployeeAttendance(data) {
    return axios.post(apibaseurl + "getAllEmployeeAttendance", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addPayrollStructureWithItems(data) {
    return axios.post(apibaseurl + "addPayrollStructureWithItems", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },

  updatePayrollStructureWithItems(data) {
    return axios.post(apibaseurl + "updatePayrollStructureWithItems", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllEmployee(data) {
    return axios.post(apibaseurl + "getEmployees", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllEarningAndDeductionItem(data) {
    return axios.post(apibaseurl + "getAllEarningAndDeductionItem", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  // getAllPayStructure(data) {
  //   return axios.post(apibaseurl + "getPayStructure", data, {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: auth,
  //     },
  //   });
  // },
  getAllEmployeeWithSalaryDetail(data) {
    return axios.post(apibaseurl + "getAllEmployeeWithSalaryDetail", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  // getAllEmployeeLeaveTypeWithStatus(data) {
  //   return axios.post(apibaseurl + "getAllEmployeeLeaveTypeWithStatus", data, {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: auth,
  //     },
  //   });
  // },
  getAllEmployeeLeaveTypeWithStatus(payLoad) {
    return axios.post(
      apibaseurl + "getAllEmployeeLeaveTypeWithStatus",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getEmployeeDashboard(payLoad) {
    return axios.post(
      apibaseurl + "getEmployeeDashboard",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAdminDashboard(payLoad) {
    return axios.post(
      apibaseurl + "getAdminDashboard",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getManagerDashboard(payLoad) {
    return axios.post(
      apibaseurl + "getManagerDashboard",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  addAttendancePunchDetails(payLoad) {
    return axios.post(
      apibaseurl + "addAttendancePunchDetails",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getEmployeeExpenseById(payLoad) {
    return axios.post(
      apibaseurl + "getEmployeeExpenseById",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAllEmployeeExpense(payLoad) {
    return axios.post(
      apibaseurl + "getAllEmployeeExpense",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAllReimbursementType(payLoad) {
    return axios.post(
      apibaseurl + "getAllReimbursementType",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  addExpenses(data) {
    return axios.post(apibaseurl + "addExpenses", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  updateExpenses(data) {
    return axios.post(apibaseurl + "updateExpenses", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  updateExpenseRequestStatus(data) {
    return axios.post(apibaseurl + "updateExpenseRequestStatus", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getEmployeeExpenseStatusLogById(payLoad) {
    return axios.post(
      apibaseurl + "getEmployeeExpenseStatusLogById",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAllReimbursementStatus(data) {
    return axios.post(apibaseurl + "getAllReimbursementStatus", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllReportedEmployee(payLoad) {
    return axios.post(
      apibaseurl + "getAllReportedEmployee",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  addEmployeeManagerDetails(data) {
    return axios.post(apibaseurl + "addEmployeeManagerDetails", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getEmployeeManagerLogById(data) {
    return axios.post(
      apibaseurl + "getEmployeeManagerLogById",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getEmployeeManagerStatusLogById(data) {
    return axios.post(
      apibaseurl + "getEmployeeManagerStatusLogById",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAllNotification(data) {
    return axios.post(apibaseurl + "getAllNotification", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getEmployeeNotificationById(payLoad) {
    return axios.post(
      apibaseurl + "getEmployeeNotificationById",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  addNotificationMasterDetail(data) {
    return axios.post(apibaseurl + "addNotificationMasterDetail", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllLeaveRequest(data) {
    return axios.post(apibaseurl + "getAllLeaveRequest", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  // getAllLeaveRequest(data) {
  //   return axios.post(apibaseurl + "getAllLeaveRequest", data, {
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   });
  // },
  addLeaveRequestDetails(data) {
    return axios.post(apibaseurl + "addLeaveRequestDetails", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addHolidayDetails(data) {
    return axios.post(apibaseurl + "addHolidayDetails", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllHolidayDetails(payLoad) {
    return axios.post(
      apibaseurl + "getAllHolidayDetails",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAllMasterDesignation(payLoad) {
    return axios.post(
      apibaseurl + "getAllMasterDesignation",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  addMasterDesignation(data) {
    return axios.post(apibaseurl + "addMasterDesignation", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterDesignation(payLoad) {
    return axios.post(
      apibaseurl + "deleteMasterDesignation",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAllMasterEmploymentStatus(payLoad) {
    return axios.post(
      apibaseurl + "getAllMasterEmploymentStatus",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  addMasterEmploymentStatus(data) {
    return axios.post(apibaseurl + "addMasterEmploymentStatus", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterEmploymentStatus(payLoad) {
    return axios.post(
      apibaseurl + "deleteMasterEmploymentStatus",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAllMasterLeaveTypes(payLoad) {
    return axios.post(
      apibaseurl + "getAllMasterLeaveTypes",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  addMasterLeaveTypes(data) {
    return axios.post(apibaseurl + "addMasterLeaveTypes", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterLeaveTypes(payLoad) {
    return axios.post(
      apibaseurl + "deleteMasterLeaveTypes",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAllMasterDepartments(payLoad) {
    return axios.post(
      apibaseurl + "getAllMasterDepartments",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },

  addMasterDepartments(data) {
    return axios.post(apibaseurl + "addMasterDepartments", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterDepartments(payLoad) {
    return axios.post(
      apibaseurl + "deleteMasterDepartments",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAllMasterEducationType(payLoad) {
    return axios.post(
      apibaseurl + "getAllMasterEducationType",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  addMasterEducationType(data) {
    return axios.post(apibaseurl + "addMasterEducationType", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterEducationType(payLoad) {
    return axios.post(
      apibaseurl + "deleteMasterEducationType",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  deleteHolidayDetails(payLoad) {
    return axios.post(
      apibaseurl + "deleteHolidayDetails",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  GetEmployeePayrollMasterDetails(data) {
    return axios.post(apibaseurl + "GetEmployeePayrollMasterDetails", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getEmployeeById(payLoad) {
    return axios.post(apibaseurl + "getEmployeeById", JSON.stringify(payLoad), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getEmployeeLeaveById(payLoad) {
    return axios.post(
      apibaseurl + "getEmployeeLeaveById",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAttendanceRegularizeById(payLoad) {
    return axios.post(
      apibaseurl + "getAttendanceRegularizeById",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  updateAttendanceRegulariseRequestDetail(data) {
    return axios.post(
      apibaseurl + "updateAttendanceRegulariseRequestDetail",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  updateAttendanceRegulariseRequestStatus(data) {
    return axios.post(
      apibaseurl + "updateAttendanceRegulariseRequestStatus",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  geAttendanceRegularizeStatusLogById(payLoad) {
    return axios.post(
      apibaseurl + "geAttendanceRegularizeStatusLogById",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAllAttendanceRequestStatus(data) {
    return axios.post(apibaseurl + "getAllAttendanceRequestStatus", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllEmployementStatus(data) {
    return axios.post(apibaseurl + "getAllEmployementStatus", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllExitReason(data) {
    return axios.post(apibaseurl + "getAllExitReason", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllEducationType(data) {
    return axios.post(apibaseurl + "getAllEducationType", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  GetEmployeeAttendanceRegulariseDates(payLoad) {
    return axios.post(
      apibaseurl + "GetEmployeeAttendanceRegulariseDates",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  addAttendanceRegulariseRequestDetail(data) {
    return axios.post(
      apibaseurl + "addAttendanceRegulariseRequestDetail",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getAllAttendanceRegularizeRequest(data) {
    return axios.post(
      apibaseurl + "getAllAttendanceRegularizeRequest",
      JSON.stringify(data),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  updateLeaveRequestDetails(data) {
    return axios.post(apibaseurl + "updateLeaveRequestDetails", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  updateNotificationDetails(data) {
    return axios.post(apibaseurl + "updateNotificationDetails", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllRequestStatus(data) {
    return axios.post(apibaseurl + "getAllRequestStatus", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAttendaceRegulariseReason(data) {
    return axios.post(apibaseurl + "getAttendaceRegulariseReason", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  updateLeaveRequestStatus(data) {
    return axios.post(apibaseurl + "updateLeaveRequestStatus", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  upload_to_AWS(data) {
    return axios.post(apibaseurl + "getSignedURL", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  //payroll
  GetEmployeePayrollMasterDetails(payLoad) {
    return axios.post(
      apibaseurl + "GetEmployeePayrollMasterDetails",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  GetFinalizePaysheetList(payLoad) {
    return axios.post(
      apibaseurl + "GetFinalizePaysheetList",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  EmployeeGenerateSalary(payLoad) {
    return axios.post(
      apibaseurl + "EmployeeGenerateSalary",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  //payslip
  GetEmployeePayslipMasterDetails(payLoad) {
    return axios.post(
      apibaseurl + "GetEmployeePayslipMasterDetails",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  GetEmployeeEarningDeductionDetails(payLoad) {
    return axios.post(
      apibaseurl + "GetEmployeeEarningDeductionDetails",
      JSON.stringify(payLoad),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  registration(user) {
    return axios.post(apibaseurl + "userregistration/add", user);
  },
  getCitiesByPin(pincode) {
    return axios.post(apibaseurl + "pincodes/get", pincode, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllBanks() {
    return axios.post(
      apibaseurl + "mstrbank/getall",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getMemberType() {
    return axios.post(
      apibaseurl + "mstrbank/getall",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: auth,
        },
      }
    );
  },
  getDashboardSummary(user) {
    return axios.post(apibaseurl + "dashboard", user, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getInvoices(user) {
    return axios.post(apibaseurl + "invoices/getByUserId", user, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getMemberList(user) {
    return axios.post(apibaseurl + "hierarchy/getMembers", user, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getHeirarchy(user) {
    return axios.post(apibaseurl + "hierarchy/get", user, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  GetRoleList(data) {
    return axios.post(apibaseurl + "GetRoleList", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  AddEditRole(data) {
    return axios.post(apibaseurl + "AddEditRole", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },

  GetMenuList(data) {
    return axios.post(apibaseurl + "GetMenuList", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  AddMenu(data) {
    return axios.post(apibaseurl + "AddMenu", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  EditMenu(data) {
    return axios.post(apibaseurl + "EditMenu", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  GetMapMenuList(data) {
    return axios.post(apibaseurl + "GetMapMenuList", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  MapMenu(data) {
    return axios.post(apibaseurl + "MapMenu", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  reset_password(data) {
    return axios.post(apibaseurl + "reset_password", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getPassword(data) {
    return axios.post(apibaseurl + "getPassword", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addUserDetails(data) {
    return axios.post(apibaseurl + "addUserDetails", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getUsers(data) {
    return axios.post(apibaseurl + "getUsers", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterUser(data) {
    return axios.post(apibaseurl + "deleteMasterUser", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getMasterUserById(data) {
    return axios.post(apibaseurl + "getMasterUserById", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  // GetEmployeeAttendaceEachMonth(data) {
  //   return axios.post(apibaseurl + "GetEmployeeAttendaceEachMonth", JSON.stringify(data), {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: auth,
  //     },
  //   });
  // },
  GetEmployeeIncomeTaxMasterDetails(data) {
    return axios.post(apibaseurl + "GetEmployeeIncomeTaxMasterDetails", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllRejectionReason(data) {
    return axios.post(apibaseurl + "getAllRejectionReason", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllExpenseRejectionReason(data) {
    return axios.post(apibaseurl + "getAllExpenseRejectionReason", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  GetReimbursementFinalizePaysheetList(data) {
    return axios.post(apibaseurl + "GetReimbursementFinalizePaysheetList", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getReimbursementPaysheetDetail(data) {
    return axios.post(apibaseurl + "getReimbursementPaysheetDetail", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addReimbursementPaysheet(data) {
    return axios.post(apibaseurl + "addReimbursementPaysheet", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllEmployeeWithReimbursementDetail(data) {
    return axios.post(apibaseurl + "getAllEmployeeWithReimbursementDetail", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  GetEmployeeIncomeTaxform24QDetails(data) {
    return axios.post(apibaseurl + "GetEmployeeIncomeTaxform24QDetails", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getEmployeeCarryForwordLeaveDetail(data) {
    return axios.post(apibaseurl + "getEmployeeCarryForwordLeaveDetail", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getEmployeeCarryForwordRemainingLeaveDetail(data) {
    return axios.post(apibaseurl + "getEmployeeCarryForwordRemainingLeaveDetail", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addEmployeeLeaveCarryForwardDetails(data) {
    return axios.post(apibaseurl + "addEmployeeLeaveCarryForwardDetails", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllQualification(data) {
    return axios.post(apibaseurl + "getAllQualification", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllMasterQualification(data) {
    return axios.post(apibaseurl + "getAllMasterQualification", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterQualification(data) {
    return axios.post(apibaseurl + "deleteMasterQualification", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addMasterQualification(data) {
    return axios.post(apibaseurl + "addMasterQualification", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllMasterPayrollDeductionItem(data) {
    return axios.post(apibaseurl + "getAllMasterPayrollDeductionItem", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addMasterPayrollDeductionItem(data) {
    return axios.post(apibaseurl + "addMasterPayrollDeductionItem", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterPayrollDeductionItem(data) {
    return axios.post(apibaseurl + "deleteMasterPayrollDeductionItem", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllMasterPayrollEarningItem(data) {
    return axios.post(apibaseurl + "getAllMasterPayrollEarningItem", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addMasterPayrollEarningItem(data) {
    return axios.post(apibaseurl + "addMasterPayrollEarningItem", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterPayrollEarningItem(data) {
    return axios.post(apibaseurl + "deleteMasterPayrollEarningItem", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllMasterProcessType(data) {
    return axios.post(apibaseurl + "getAllMasterProcessType", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addMasterProcessType(data) {
    return axios.post(apibaseurl + "addMasterProcessType", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterProcessType(data) {
    return axios.post(apibaseurl + "deleteMasterProcessType", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllMasterRejectionReason(data) {
    return axios.post(apibaseurl + "getAllMasterRejectionReason", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addMasterRejectionReason(data) {
    return axios.post(apibaseurl + "addMasterRejectionReason", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterRejectionReason(data) {
    return axios.post(apibaseurl + "deleteMasterRejectionReason", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllMasterReimbursementType(data) {
    return axios.post(apibaseurl + "getAllMasterReimbursementType", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addMasterReimbursementType(data) {
    return axios.post(apibaseurl + "addMasterReimbursementType", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterReimbursementType(data) {
    return axios.post(apibaseurl + "deleteMasterReimbursementType", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllMasterLocation(data) {
    return axios.post(apibaseurl + "getAllMasterLocation", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addMasterLocation(data) {
    return axios.post(apibaseurl + "addMasterLocation", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterLocation(data) {
    return axios.post(apibaseurl + "deleteMasterLocation", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllMasterExitReason(data) {
    return axios.post(apibaseurl + "getAllMasterExitReason", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addMasterExitReason(data) {
    return axios.post(apibaseurl + "addMasterExitReason", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterExitReason(data) {
    return axios.post(apibaseurl + "deleteMasterExitReason", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllMasterAttendanceRegularizeReason(data) {
    return axios.post(apibaseurl + "getAllMasterAttendanceRegularizeReason", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addMasterAttendanceRegularizeReason(data) {
    return axios.post(apibaseurl + "addMasterAttendanceRegularizeReason", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterAttendanceRegularizeReason(data) {
    return axios.post(apibaseurl + "deleteMasterAttendanceRegularizeReason", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllMasterTaxSlab(data) {
    return axios.post(apibaseurl + "getAllMasterTaxSlab", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addMasterTaxSlab(data) {
    return axios.post(apibaseurl + "addMasterTaxSlab", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterTaxSlab(data) {
    return axios.post(apibaseurl + "deleteMasterTaxSlab", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllAttendanceRejectionReason(data) {
    return axios.post(apibaseurl + "getAllAttendanceRejectionReason", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  getAllMasterAnnualYearLeave(data) {
    return axios.post(apibaseurl + "getAllMasterAnnualYearLeave", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  addMasterAnnualYearLeave(data) {
    return axios.post(apibaseurl + "addMasterAnnualYearLeave", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  deleteMasterAnnualYearLeave(data) {
    return axios.post(apibaseurl + "deleteMasterAnnualYearLeave", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
  GetEmployeeAttendanceRegularise(data) {
    return axios.post(apibaseurl + "GetEmployeeAttendanceRegularise", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
        Authorization: auth,
      },
    });
  },
};
